<template>
    <div class="llp-file-loader">
        <input :id="id" ref="fileLoader" :accept="accept" :class="classNames" :disabled="disabled" :name="id"
               class="form-control" type="file" @change="$emit('change:input', $event)">
        <span v-if="errors.length === 1" class="text-danger">
            {{ errors[0].$message }}
        </span>
        <ul v-else-if="errors.length > 1" class="m-0">
            <li v-for="error in errors" :key="error.$uid" class="text-danger">
                <span class="text-danger">{{ error.$message }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'BaseFileLoader',
  props: {
    id: {
      type: String,
      required: true,
    },
    accept: {
      type: String,
      required: false,
      default: '',
    },
    classNames: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    errors: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  methods: {
    clean() {
      this.$refs.fileLoader.value = null;
    },
  },
};
</script>
